/**
 * 依觸發元件與視窗可視區，判斷下拉是否應改為向上展開，避免超出畫面下緣。
 *
 * @param {{ top: number, bottom: number }} anchorRect - 觸發區 getBoundingClientRect()
 * @param {object} [options]
 * @param {number} [options.estimatedDropdownHeight=320] - 預估下拉高度 (px)
 * @param {number} [options.viewportHeight] - 預設為 window.innerHeight
 * @param {number} [options.edgeMargin=8] - 與視窗邊緣保留間距 (px)
 * @returns {boolean} 是否應使用向上展開的樣式（例如 `.top` / `calendar--open-up`）
 */
export function shouldOpenDropdownUpward(anchorRect, options = {}) {
  if (!anchorRect || typeof anchorRect.bottom !== 'number') {
    return false;
  }
  const viewportHeight =
    options.viewportHeight != null
      ? options.viewportHeight
      : typeof window !== 'undefined'
        ? window.innerHeight
        : 0;
  const estimatedDropdownHeight =
    options.estimatedDropdownHeight != null ? options.estimatedDropdownHeight : 320;
  const edgeMargin = options.edgeMargin != null ? options.edgeMargin : 8;

  const spaceBelow = viewportHeight - anchorRect.bottom;
  const spaceAbove = anchorRect.top;

  if (spaceBelow >= estimatedDropdownHeight + edgeMargin) {
    return false;
  }
  if (spaceAbove >= estimatedDropdownHeight + edgeMargin) {
    return true;
  }
  return spaceAbove >= spaceBelow;
}
